<template>
  <div class="container align-left">
    <div class="row">
      <div class="col lg-8">
         This is a fun way of arranging and scheduling work with productive outcomes. "Dates with Delivery"
          <p></p>
          As in human dating there has to be value for yourself - or you would not do it. So it should be with work.
          <p></p>
          The way we anticipate, plan, prepare and peform on dates is fun and the outcomes can be valuable in the short and long term.
          <p></p>
          Shifting that sense of anticiapation to a work setting we can use Tinder-a-like swiping to select backlog items for estimation and delivery to gain value.
          <p></p>

          <p></p>
          Step two is a fast a profile. We use Scan, Analyse, Lean, Value (SALVe) techniques to provide time to overcome complexity
          <p></p>
          The genreic model and some of its variants are shown below
          <p></p>
      </div>
      <!-- <div class="col col-lg-4">
        <h2>Upload File</h2>
        <!-- <textarea name="items" id="items" cols="30" rows="10"></textarea>
        Select your dates from the backlog items...
        <p></p>
        <div class="row">
          <!-- <div class="col col-lg-1"> -->
            <!-- <button @click="saveBacklog()" class="btn btn-primary">Save Backlog</button> -->
          <!-- </div> -->
          <!-- <div class="col col-lg-1">
            <button @click="saveBacklogAs()" class="btn btn">Save Backlog As</button>
          </div> -->
          <!-- <div class="col col-lg-1"> -->
            <!-- <button @click="loadBacklog()" class="btn btn-warning">Load previous</button> -->
          <!-- </div> -->
        <!-- </div> -->

      <!-- </div>  -->
      <div>
         <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">
        <h1>Upload Items</h1>
        <div class="dropbox">
          <input type="file" multiple :name="uploadFieldName" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
            accept="text/*" class="input-file">
            <p v-if="isInitial">
              Drag your file(s) here to begin<br> or click to browse
            </p>
            <p v-if="isSaving">
              Uploading {{ fileCount }} files...
            </p>
        </div>
      </form>
      <button class="btn btn-warning">Save As</button>
      </div>
    </div>

    <div class="row">
      <div class="col col-lg-6">
       <img src="../assets/salve.png"  width="400px" class="img img-responsive" />
      </div>

      <div class="col col-lg-6">
      <table class="table">
        <thead>
          <th>Profile</th>
          <th>Description</th>
        </thead>
        <tbody>
          <tr>
            <td><img src="../assets/guitar.png"></td>
            <td>Short no value</td>
          </tr>
          <tr>
            <td><img src="../assets/drum.png"></td>
            <td>Enabler - vlaue only</td>
          </tr>
          <tr>
            <td><img src="../assets/horns.png"></td>
            <td>Medium effort and value</td>
          </tr>
          <tr>
            <td><img src="../assets/synth-texture.png"></td>
            <td>Sustained Value</td>
          </tr>
        </tbody>
      </table>
      </div>
    </div>
    <p></p>
    The model is generic and scaleable.
    <p></p>
    A brief overview of the steps in each secton is given below.
    <p></p>
    <div class="row">
      <div class="col col-lg-3">
        <h4 style="color:red;">Scan</h4>
        <p style="margin-left: 20px">
        <ul>
          <li>Envirionment</li>
          <li>Other People</li>
          <li>Self</li>
        </ul>
        </p>
      </div>
      <div class="col col-lg-3">
        <h4 style="color:#ff8b33;">Analyse</h4>
        <p style="margin-left: 20px">
        <ul>
          <li>Critical</li>
          <li>Creative</li>
          <li>Cognitive</li>
        </ul>
        </p>
      </div>
      <div class="col col-lg-3">
        <h4 style="color:green;">Lean</h4>
        <p style="margin-left: 20px">
        <ul>
          <li>Plan & Commit</li>
          <li>Build</li>
          <li>Deliver</li>
        </ul>
        </p>
      </div>
      <div class="col col-lg-3">
        <h4 style="color:blue;">Value</h4>
        <p style="margin-left: 20px">
        <ul>
          <li>Absorb</li>
          <li>Impact</li>
          <li>Reflect</li>
        </ul>
        </p>
      </div>
    </div>
    <p></p>
    The important pieces in estimation are complexity and duration so we provide the Dates page to visually plan.
    <p></p>
    Complexity is solved by learning: application is the path to Personal Mastery.
    <p></p>
  </div>
</template>

<script>


  const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;


  export default {
    name: "About",
    data() {
      return {
        uploadedFiles: [],
        uploadError: null,
        currentStatus: null,
        uploadFieldName: 'photos',
        items: ""
      }
    },
    mounted() {
      this.reset()
    },
    computed: {
      isInitial() {
        return this.currentStatus === STATUS_INITIAL;
      },
      isSaving() {
        return this.currentStatus === STATUS_SAVING;
      },
      isSuccess() {
        return this.currentStatus === STATUS_SUCCESS;
      },
      isFailed() {
        return this.currentStatus === STATUS_FAILED;
      }
    },
    methods: {
      reset() {
        // reset form to initial state
        this.currentStatus = STATUS_INITIAL;
        this.uploadedFiles = [];
        this.uploadError = null;
      },
      save(formData) {
        // upload data to the server
        this.currentStatus = STATUS_SAVING;

        this.upload(formData)
          .then(this.wait(1500)) // DEV ONLY: wait for 1.5s
          .then(x => {
            this.uploadedFiles = [].concat(x);
            this.currentStatus = STATUS_SUCCESS;
          })
          .catch(err => {
            this.uploadError = err.response;
            this.currentStatus = STATUS_FAILED;
          });
      },
      wait(ms) {
        return (x) => {
            return new Promise(resolve => setTimeout(() => resolve(x), ms));
        };
      },
      filesChange(fieldName, fileList) {
        // handle file changes
        const formData = new FormData();

        if (!fileList.length) return;

        // append the files to FormData
        Array
          .from(Array(fileList.length).keys())
          .map(x => {
            formData.append(fieldName, fileList[x], fileList[x].name);
          });

        // save it
        this.save(formData);
      },
      upload(formData) {
        const photos = formData.getAll('photos');
        const promises = photos.map((x) => this.getItems(x)
            .then(img => ({
                id: img,
                originalName: x.name,
                fileName: x.name,
                url: img
            })));
        return Promise.all(promises);
      },
      getItems(file) {
          console.log("I")
          return new Promise((resolve, reject) => {
              const fReader = new FileReader();
              // const img = document.createElement('img');

              fReader.onload = () => {
                  // img.src = fReader.result;
                  // resolve(getBase64Image(img));
                  this.items = fReader.result;
                  console.log(this.items)
                  //split
                  let _items = this.items.split("\n")
                  console.log(_items)
                  this.$store.dispatch("clearItems")
                  //save to Vuex state
                  _items.forEach(item => {
                     let payload = {
                        name: item,
                        rating: 3,
                        approved: null,
                        complexity: 0,
                        duration: 0,
                        profile: { value: 0, img: require("@/assets/blank.png") },
                        layout: { x: -1, y: -1, scaleX: -100, scaleY: -100 }
                      }
                      this.$store.dispatch("addItem", payload)
                  })
              }
              fReader.readAsText(file);
              // console.log(this.items)
          })
      },
      saveBacklog() {
        console.log("I am saving")
        //
        alert("Backlog saved")
      }
    }
  }
</script>

<style scoped>
.align-left {
  text-align: left;
}
html,body{overflow-y: scroll; }

.dropbox {
    outline: 2px dashed grey; /* the dash box */
    outline-offset: -10px;
    background: lightcyan;
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px; /* minimum height */
    position: relative;
    cursor: pointer;
  }

  .input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }

  .dropbox:hover {
    background: lightblue; /* when mouse over to the drop zone, change color */
  }

  .dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
  }
</style>